import React, { useEffect } from 'react';
import { Phone, PhoneOff, Video } from 'lucide-react';

const IncomingCallModal = ({ callData, onAccept, onReject }) => {
  const callerName = callData?.caller_name || 'Someone';
  const isVideo = callData?.is_video;

  return (
    <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="incoming-call-modal">
      <div className="bg-[#0F172A] rounded-2xl p-8 max-w-sm w-full mx-4 text-center shadow-2xl border border-white/10">
        {/* Animated avatar ring */}
        <div className="relative mx-auto w-24 h-24 mb-6">
          <div className="absolute inset-0 rounded-full bg-[#4338CA]/30 animate-ping" />
          <div className="absolute inset-1 rounded-full bg-[#4338CA]/20 animate-pulse" />
          <div className="relative w-24 h-24 rounded-full bg-[#4338CA] flex items-center justify-center text-white text-3xl font-bold">
            {callerName.charAt(0).toUpperCase()}
          </div>
        </div>

        <h2 className="text-white text-xl font-bold mb-1" data-testid="caller-name">{callerName}</h2>
        <p className="text-white/60 text-sm mb-8">
          {isVideo ? 'Incoming Video Call...' : 'Incoming Voice Call...'}
        </p>

        <div className="flex items-center justify-center gap-8">
          {/* Reject */}
          <button
            onClick={onReject}
            className="flex flex-col items-center gap-2 group"
            data-testid="reject-call-button"
          >
            <div className="w-16 h-16 rounded-full bg-red-500 flex items-center justify-center shadow-lg shadow-red-500/30 group-active:scale-90 transition-transform">
              <PhoneOff className="text-white w-7 h-7" />
            </div>
            <span className="text-white/60 text-xs">Decline</span>
          </button>

          {/* Accept */}
          <button
            onClick={onAccept}
            className="flex flex-col items-center gap-2 group"
            data-testid="accept-call-button"
          >
            <div className="w-16 h-16 rounded-full bg-green-500 flex items-center justify-center shadow-lg shadow-green-500/30 group-active:scale-90 transition-transform animate-bounce">
              {isVideo ? <Video className="text-white w-7 h-7" /> : <Phone className="text-white w-7 h-7" />}
            </div>
            <span className="text-white/60 text-xs">Accept</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncomingCallModal;
